import script from "./OssUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./OssUpload.vue?vue&type=script&setup=true&lang=js"

import "./OssUpload.vue?vue&type=style&index=0&id=c7362bac&lang=scss&scoped=true"
import "./OssUpload.vue?vue&type=style&index=1&id=c7362bac&lang=css"

import exportComponent from "/root/workspace/public_sso_ZgiA/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7362bac"]])

export default __exports__